import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& > svg': {
                margin: theme.spacing(2),
            },
        },
    }),
);
function DownloadIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <line className="customIcon" x1="12.001" y1="3.75" x2="12.001" y2="15.75" /><polyline className="customIcon" points="7.501 11.25 12.001 15.75 16.501 11.25" /><path className="customIcon" d="M23.251,15.75v1.5a3,3,0,0,1-3,3H3.751a3,3,0,0,1-3-3v-1.5" />
        </SvgIcon>
    );
}
function MailIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <rect className="customIcon" x="1.5" y="4.75" width="21" height="15" rx="1.5" ry="1.5" /><path className="customIcon" d="M22.161,5.3l-8.144,6.264a3.308,3.308,0,0,1-4.034,0L1.839,5.3" />
        </SvgIcon>
    );
}
function FeedbackIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path className="customIcon" d="M6.75,15.25H4.5a3.75,3.75,0,0,1,0-7.5H6.75Z" /><path className="customIcon" d="M6.75,15.25a22.3,22.3,0,0,1,12.366,3.744l1.134.756V3.25l-1.134.756A22.3,22.3,0,0,1,6.75,7.75Z" /><line className="customIcon" x1="23.25" y1="10" x2="23.25" y2="13" /><path className="customIcon" d="M6.75,15.25A7.239,7.239,0,0,0,9,20.5" />
        </SvgIcon>
    );
}
export { DownloadIcon, MailIcon, FeedbackIcon } ;

